var map = {
	"./chicken-satay-lettuce-wraps/intro": 4943,
	"./chili-garlic-spicy-noodles/intro": 4784,
	"./dak-galbi/intro": 1346,
	"./detroit-style-pizza/intro": 7502,
	"./eggplant-parmesan/intro": 1319,
	"./lavash-triangles/intro": 2475,
	"./pasta-amatriciana/intro": 2641,
	"./samoas-cookies/intro": 7075,
	"./springtime-saffron-pasta/intro": 7226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6879;